import React, {useEffect, useState} from 'react';
import VisitorPie1 from "./VisitorPie1";
import VisitorPie2 from "./VisitorPie2";
import VisitorPie3 from "./VisitorPie3";
import VisitorPie4 from "./VisitorPie4";
const VisitorTop = () => {
    const month = ["Янв ","Фев ","Мар ","Апр","Май","Июн","Июл ","Авг","Сен","Окт","Ноя","Дек",]

    return (
        <div className="visitor visitor-box">
            <div className="visitor-top">
                <div className="row">
                    <div className="col-lg-6 col-xl-3 col-md-6 col-sm-12 mt-2">
                        <VisitorPie1
                            month={month}/>
                    </div>
                    <div className="col-lg-6 col-xl-3 col-md-6 col-sm-12 mt-2">
                        <VisitorPie2 />

                    </div>
                    <div className="col-lg-6 col-xl-3 col-md-6 col-sm-12 mt-2">
                        <VisitorPie3 />

                    </div>
                    <div className="col-lg-6 col-xl-3 col-md-6 col-sm-12 mt-2">
                        <VisitorPie4 />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisitorTop;